<template>
  <div class="message-item">
    <div class="message-item-content" v-if="messageItem.user_id !== selfId">
      <el-avatar class="avatar" size="large" :src="messageItem.avatar" @error="() => true">
        <img src="https://live-oss.busionline.com/assets/images/avatars/user_default.png" alt srcset>
      </el-avatar>
      <div class="message-info">
        <div class="name">{{messageItem.username}}</div>
        <div class="normal-content">
          <span class="message-wrapper">{{messageItem.content}}</span>
        </div>
      </div>
    </div>
    <div class="message-item-content is-self" v-else>
      <div class="message-info">
        <div class="name">我</div>
        <div class="normal-content">
          <span class="message-wrapper">{{messageItem.content}}</span>
        </div>
      </div>
      <el-avatar class="avatar" size="large" :src="messageItem.avatar" @error="() => true">
        <img src="https://live-oss.busionline.com/assets/images/avatars/user_default.png" alt srcset>
      </el-avatar>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['messageItem','selfId']
  }
</script>

<style lang="scss" scoped>
  .message-item {
    margin-bottom: 32px;
    &:last-child{
      margin-bottom: 0;
    }
    .message-item-content{
      display: flex;
      width: 328px;
      justify-content: space-between;
      .avatar{
        width: 40px;
        height: 40px;
        img{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .message-info {
        width: 274px;
        font-size: 16px;
        .name{
          padding: 4px 0 8px;
          color: #1678FF;
        }
        .normal-content {
          position: relative;
          display: inline-block;
          width: 100%;
          white-space: wrap;
          word-break: break-word;
          .message-wrapper {
            cursor: default;
            position: relative;
            display: inline-block;
            padding: 12px;
            background-color: #fff;
            line-height: 24px;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
            color: #333;
          }
          &::before {
            content: "";
            position: absolute;
            right: 100%;
            top: 0;
            z-index: 99;
            width: 0px;
            border-top: 3px solid #fff;
            border-right: 3px solid #fff;
            border-left: 3px solid transparent;
            border-bottom: 3px solid transparent;
          }
        }
      }
      &.is-self{
        .message-info {
          text-align: right;
          .normal-content {
            .message-wrapper {
              text-align: left;
              background-color: #1678FF;
              color: #fff;
            }
            &::before {
              display: none;
            }
            &::after {
              content: "";
              position: absolute;
              left: 100%;
              top: 0;
              width: 0px;
              border-top: 3px solid #1678FF;
              border-left: 3px solid #1678FF;
              border-right: 3px solid transparent;
              border-bottom: 3px solid transparent;
            }
          }
        }
      }
    }
  }
</style>
